export default __webpack_public_path__ + "static/media/greyMarker.19457519.svg";